import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import { ZIndexLayer } from "shared/lib/styles";

import { Drawer } from "scmp-app/components/common/drawer";
import { rosettaAtom } from "scmp-app/lib/rosetta";

import { Button, Content, Message, Title } from "./styles";

type Props = {
  contentLocked?: boolean;
};

export const PostiesPaywallContainer: FunctionComponent<Props> = ({ contentLocked }) => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const shouldShowPaywall =
    asyncRosettaState?.result?.hasPianoExperienceExecuted &&
    !asyncRosettaState?.result?.posties?.disablePaywall &&
    !asyncRosettaState?.result?.hasPostiesAccessRight &&
    asyncRosettaState?.result?.contentServiceUserInfo?.isSubscriptionEnabled === true &&
    contentLocked === true;

  if (!shouldShowPaywall) {
    return null;
  }

  return (
    <Drawer
      anchor="bottom"
      open={true}
      PaperProps={{
        sx: {
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        },
      }}
      sx={{
        zIndex: `${ZIndexLayer.AppBar - 1}`,
      }}
    >
      <Content>
        <Title>Something Big is Coming!</Title>
        <Message>
          <p>
            Our subscriptions are temporarily on pause as we prepare to launch our new digital
            platform and updated packages this September.
          </p>
          <p>
            Be the first to know! Leave your email{" "}
            <a href="https://x17793v7476.typeform.com/posties" rel="noreferrer" target="_blank">
              here
            </a>{" "}
            and be the first to access our new subscriptions when they launch.
          </p>
          <p>Thank you for your patience!</p>
        </Message>
        <a href="https://x17793v7476.typeform.com/posties" rel="noreferrer" target="_blank">
          <Button>
            <span>Register</span>
          </Button>
        </a>{" "}
      </Content>
    </Drawer>
  );
};

PostiesPaywallContainer.displayName = "PostiesPaywallContainer";
